import { render, staticRenderFns } from "./g-logo.vue?vue&type=template&id=339d9a2b"
import script from "./g-logo.vue?vue&type=script&lang=js"
export * from "./g-logo.vue?vue&type=script&lang=js"
import style0 from "./g-logo.vue?vue&type=style&index=0&id=339d9a2b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports